import { services } from '../services';
var action = "bookingpayment";

export const bookingpaymentService = {
    getList,
    getOne,
    insert,
    update,
    remove,
    getListByBooking,
    getReceipt
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}
function getListByBooking(id) {
    return services.restApi(`${action}/booking/${id}`, 'GET');
}
function insert(object) {
    return services.restApi(`${action}`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}

function getReceipt(id) {
    return services.restApi(`${action}/receipt/${id}`, 'GET');
}